<template>

  <div>


    <b-breadcrumb class="d-none d-lg-flex">
      <b-breadcrumb-item>Administratie</b-breadcrumb-item>
      <b-breadcrumb-item to="/main/admin/printers">Printers</b-breadcrumb-item>
      <b-breadcrumb-item active>{{printer.serial}}</b-breadcrumb-item>
    </b-breadcrumb>

    <div class="d-none d-lg-flex align-items-center justify-content-between">
      <h2>Printer {{printer.serial}}</h2>
      <b-btn><span class="mdi mdi-pencil"/> Bewerken</b-btn>
    </div>



    <p>
      <template v-if="printer.device">
        Verbonden via <b-link :to="`/main/admin/bigfox/view/${printer.device.id}`">{{printer.device.displayName}} <small>({{printer.device.serial}})</small></b-link> <b-badge>{{printer.device.status}}</b-badge>, IP adres: {{printer.snmpHost}}
      </template>
      <template v-else>
        Niet verbonden met Bigfox
      </template>
    </p>

    <p v-if="printer.model">
        Merk en model: {{printer.model.brand.name}} {{printer.model.name}}<br>
      <span v-if="printer.model.profile">
        Profiel: {{printer.model.profile.name}}
      </span>
      <span v-else>
        <span class="text-danger">Geen profiel toegewezen</span>
      </span>

    </p>

    <h3>Contracten</h3>

    <ul>
      <li v-for="(e) in printer.contractPrinters.nodes" :key="e.id">
        <b-link :to="`/main/admin/contracts/view/${e.contract.id}`">{{e.contract.name}}</b-link>
      </li>
    </ul>

    <h3>Tellers</h3>

    <b-tabs content-class="mt-3" v-model="trackTab">
      <!-- This tabs content will always be mounted -->
      <b-tab title="Laatste stand">
        <p>
          <b-btn @click="counters" variant="primary"><span class="mdi mdi-counter"/> Tellers bijwerken</b-btn>
        </p>
        <b-table :items="printer.lasts.nodes" :fields="$options.fields" small fixed>
          <template #cell(tsms)="{value}">{{value|format_duration($store.state.now)}}</template>
        </b-table>
      </b-tab>

      <b-tab title="Geschiedenis" lazy>
        <printer-history :id="id" />
      </b-tab>

      <b-tab title="SNMP verkennen" lazy>
        <snmp-walk :printer-id="printer.printerId" />
      </b-tab>
    </b-tabs>

  </div>

  
</template>

<script>

import gql from 'graphql-tag';

import PrinterHistory from '@/components/PrinterHistory';
import SnmpWalk from '../../components/SnmpWalk';
import trackTab from '@/lib/trackTab';
import {M_SET_SUBTITLE} from '@/lib/constants';

export default
{
    apollo:
    {
        $subscribe:
        {
            printer:
            {
                query: require('../../graphql/viewPrinter.sub.gql'),
                variables()
                {
                    return { id: this.id }
                },
                result({data: {printer}})
                {
                    this.printer = printer;
                    this.$store.commit(M_SET_SUBTITLE, printer.serial);
                }
            }
        }
    },
    components: { PrinterHistory, SnmpWalk },
    computed:
    {
        trackTab: trackTab('t')
    },
    data()
    {
        return {
            printer: { lasts: {}, device: {}, model: { brand: {} }, contractPrinters: { nodes: [] } }
        }
    },
    methods:
    {
        counters()
        {
            this.$apollo.mutate(
                {
                    mutation: gql`
                        mutation MyMutation($id: ID!) {
                            updateCountersForPrinter(input: {id: $id})
                        }`,
                    variables: { id: this.id }
                }
            ).then(console.log);
        }
    },
    props: [ 'id' ],
    fields:
    [
        {
            key: 'cgroup.displayName',
            label: 'Tellergroep'
        },
        {
            key: 'tsms',
            label: 'Laatst bijgewerkt'
        },
        {
            key: 'value',
            label: 'Stand'
        }
    ]
}
</script>

<style>
</style>